<template>
  <div class="col-12 connections py-4 mb-4">
    <div class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">Заключенные контракты</h5>
      </div>
      <div class="card-body">
        <template v-if="contracts?.length">
          <div class="d-flex justify-content-between flex-md-row flex-column gap-3 mb-4">
            <div class="filter-container d-flex align-items-center my-2">
              <label for="law-filter">Закон</label>
              <select id="law-filter" v-model="selectedLaw" class="form-select w-auto ms-4">
                <option value="all">Все</option>
                <option value="44">44-ФЗ</option>
                <option value="94">94-ФЗ</option>
                <option value="223">223-ФЗ</option>
              </select>
            </div>

            <div class="filter-container d-flex align-items-center my-2">
              <label for="search-filter">Поиск</label>
              <input
                id="search-filter"
                v-model.trim="searchQuery"
                type="text"
                class="form-control ms-4"
                placeholder="Контрагент или предмет закупки"
              />
            </div>
          </div>

          <div class="contracts-summary row gy-3 mb-4">
            <div class="col-md-4">
              <div class="contracts-summary__item">
                <span class="label">Контрактов</span>
                <strong>{{ filteredContracts.length }}</strong>
              </div>
            </div>
            <div class="col-md-4">
              <div class="contracts-summary__item">
                <span class="label">Общая сумма</span>
                <strong>{{ formatPrice(totalPrice) }}</strong>
              </div>
            </div>
            <div class="col-md-4">
              <div class="contracts-summary__item">
                <span class="label">Крупнейший контракт</span>
                <strong>{{ formatPrice(maxPrice) }}</strong>
              </div>
            </div>
          </div>

          <div class="connections-list-container">
            <div v-for="contract in filteredContracts" :key="contract.id" class="connections-list">
              <div class="connections-list__header">
                <p>
                  № {{ contract.register_number || 'без номера' }} от {{ formatDate(contract.date) }}
                </p>
                <span class="status active">{{ formatLaw(contract.law) }}</span>
              </div>
              <div class="connections-list__body col-10">
                <p class="value"><span class="label">Сумма</span> {{ formatPrice(contract.price) }}</p>
                <p class="value"><span class="label">Заказчик</span>{{ contract.customer?.name || 'Нет данных' }}</p>
                <p class="value"><span class="label">Поставщик</span>{{ contract?.contract_provider?.[0]?.name || 'Нет данных' }}</p>
                <p v-for="object in contract.purchase_objects" :key="object.id" class="value">
                  <span class="label">Предмет закупки</span> {{ object.name || 'Нет данных' }}
                </p>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <p class="text-center mb-0">Нет данных о контрактах</p>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
  import { defineComponent, ref, computed } from 'vue';
  import moment from 'moment';

  export default defineComponent({
    name: 'Contracts',
    props: {
      contracts: {
        type: Array,
        default: () => [],
      },
    },
    setup(props) {
      const selectedLaw = ref('all');
      const searchQuery = ref('');

      const filteredContracts = computed(() => {
        return (props.contracts || []).filter((contract) => {
          const lawMatch = selectedLaw.value === 'all' || String(contract.law) === selectedLaw.value;
          const haystack = [
            contract.customer?.name,
            contract.contract_provider?.[0]?.name,
            ...(contract.purchase_objects || []).map((item) => item.name),
          ]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();
          const searchMatch = !searchQuery.value || haystack.includes(searchQuery.value.toLowerCase());
          return lawMatch && searchMatch;
        });
      });

      const formatDate = (date) => {
        return date ? moment(date).format('DD.MM.YYYY') : 'Нет данных';
      };

      const formatPrice = (price) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          maximumFractionDigits: 0,
        }).format(Number(price) || 0);
      };

      const formatLaw = (law) => {
        return law ? `${law}-ФЗ` : 'Без закона';
      };

      const totalPrice = computed(() =>
        filteredContracts.value.reduce((sum, contract) => sum + (Number(contract.price) || 0), 0)
      );
      const maxPrice = computed(() =>
        filteredContracts.value.reduce((max, contract) => Math.max(max, Number(contract.price) || 0), 0)
      );

      return {
        selectedLaw,
        searchQuery,
        filteredContracts,
        formatDate,
        formatPrice,
        formatLaw,
        totalPrice,
        maxPrice,
      };
    },
  });
</script>
<style scoped lang="scss">
  .contracts-summary__item {
    height: 100%;
    padding: 1rem 1.25rem;

    background: #f4f6fa;
    border-radius: 14px;

    .label {
      display: block;
      margin-bottom: 0.5rem;
      color: #6d7785;
      font-size: 14px;
    }

    strong {
      color: #3e3e3e;
      font-size: 20px;
    }
  }
</style>
